export default __webpack_public_path__ + "static/media/GreenFace.d87b775d.gif";